<template>
  <div>
    <div class="mb-2">
      <i class="mr-2 fas fa-clock mb-1 text-orange" />
      <label class="font-16 color-black font-weight-bold">
        Historial de Estatus
      </label>
    </div>

    <time-line class="historial-line mt-4">
      <time-line-item v-for="item of visibleItems" :key="`History-${item.id}`">
        <template #date>
          <span class="color-secondary-6 font-12">Fecha:</span>
          <p class="color-black font-16 font-weight-bold">
            {{ $formatDate(item.createdDate, $templateDate.longDateWithHour) }}
          </p>
        </template>

        <div id="main-info" class="row  align-items-center">
          <div class="col-12 col-md-2 additional-evaluation ml-2 mt-1">
            <custom-balloon
              :background-color="item.status.color"
              dot
              :text="item.status?.name"
            />
          </div>

          <div class="col-12 col-md-3 mt-3 mt-md-0 mt-sm-3">
            <div class="color-secondary-6 font-14">
              Usuario:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.userFullName | capitalize }}
            </div>
          </div>
          <div v-if="item.comment" class="col-12 col-md-6 mt-3 mt-md-0 mt-sm-3">
            <div class="color-secondary-6 font-14">
              Comentario:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.comment }}
            </div>
          </div>
        </div>
      </time-line-item>
    </time-line>

    <div class="row">
      <div v-if="canShowMore" class="col-12 d-flex justify-content-center my-3">
        <action-button
          variant="outline-success custom-view-more actionButton rounded-pill"
          @click="loadMore"
        >
          Ver más
          <i class="ml-1 fas fa-chevron-down" />
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import { getLog } from '@/modules/medicaid/medicaid-certification.api';
import CustomBalloon from 'custom-balloon';
export default {
  name: 'MedicaidHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomBalloon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { history: [], visibleCount: 1 };
  },
  computed: {
    canShowMore() {
      return this.history.length > this.visibleCount;
    },
    visibleItems() {
      return this.history.slice(0, this.visibleCount);
    },
  },
  async mounted() {
    this.getLogHistory();
  },
  methods: {
    async getLogHistory() {
      const { data } = await getLog(this.item.id);
      this.history = data;
    },
    loadMore() {
      this.visibleCount += 1;
    },
  },
};
</script>
<style scoped>
::v-deep .icon-mr-0 {
  margin-right: 0 !important;
}
</style>
